import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { Form, actions } from 'react-redux-form/immutable'

import Wizard from 'components/Wizard'
import { required, intRequired, isEmail } from 'utils/validators'

import StudentData from './student-data'
import StudentAdvising from './student-advising'
import StudentAccount from './student-account'
import Final from './final'
import CustomErrors from './custom-errors'
import { admitStudent } from './actions'

const steps = [
  'Student Data',
  'Advising',
  'Account',
]

const validators = {
  last_name: { required },
  first_name: { required },
  sex: { required },
  dob: { required },
  civil_status: { required },
  // advising
  level: { intRequired },
  course_id: { intRequired },
  curriculum_id: { intRequired },
  paymentscheme_id: { intRequired },
  // account
  username: { required },
  email: { isEmail },
}

class Admission extends Component {

  constructor(props) {
    super(props)

    this.state = {
      step: 0,
      complete: {},
    }
  }

  _setStep = (step) => {
    this.setState({
      step,
    })
  }

  _newAdmission = () => {
    // dispatch reset
    this.props.dispatch(actions.reset('admissionState'))
    this.setState({
      step: 0,
      complete: {},
    })
  }

  _onSubmit = (input) => {
    this.props.dispatch(admitStudent(input))
      .then((res) => {
        if (!res.error) {
          this.props.dispatch(actions.reset('admissionState'))
          this.setState({
            step: 3,
            complete: fromJS(res.payload),
          })
        }
      })
  }

  _renderHeader(step) {
    const { __session } = this.props

    if (step !== 3) {
      return (
        <div>
          <h3>Admit New Student in <strong className="text-primary">{__session.get('sy')} - {__session.get('sem')}</strong></h3>
          {this._renderWizard(step)}
        </div>
      )
    } else {
      return (
        <div>
          <h3>Admission Complete</h3>
          <button type="button" onClick={this._newAdmission} className="btn btn-primary">New Admission</button>
        </div>
      )
    }
  }

  _renderWizard(step) {
    return <Wizard items={steps} step={step} onClick={this._setStep} />
  }

  _renderContent(step) {
    const { complete } = this.state

    switch (step) {
      case 0:
        return <StudentData setStep={this._setStep} />

      case 1:
        return <StudentAdvising setStep={this._setStep} />

      case 2:
        return <StudentAccount setStep={this._setStep} />

      default:
        return <Final data={complete} />
    }
  }

  render() {
    const { step } = this.state

    return (
      <div>
        {this._renderHeader(step)}
        <hr />
        <Form
          model="admissionState"
          className="grid-form"
          validators={validators}
          onSubmit={this._onSubmit}
        >
          <CustomErrors />
          {this._renderContent(step)}
        </Form>
      </div>
    )
  }
}

Admission.propTypes = {
  __session: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    __session: state.auth.get('session'),
  }
}

export default connect(mapStateToProps)(Admission)



// WEBPACK FOOTER //
// ./src/containers/Admission/index.js